export default __webpack_public_path__ + "static/media/icon-check-blue.86fd6033.svg";